import { render } from "./proche_history.vue?vue&type=template&id=66a1a4e5&scoped=true"
import script from "./proche_history.vue?vue&type=script&lang=js"
export * from "./proche_history.vue?vue&type=script&lang=js"

import "./proche_history.vue?vue&type=style&index=0&id=66a1a4e5&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a1a4e5"]])

export default __exports__